/**
 * 点击路由跳转基础配置
 */
import {
    // eslint-disable-next-line no-unused-vars
    mapState,
    mapGetters,
    mapActions
} from 'vuex';

// eslint-disable-next-line no-unused-vars
const STORE_CART = 'STORE_CART';
const STORE_ORDER_PACKAGE = 'STORE_ORDER_PACKAGE';
const Mixins = {
    data() {
        return {
            storeCardList: []
        };
    },
    computed: {
        ...mapGetters('store', {
            storeCard: 'storeCard',
            storeCardLen: 'storeCardLen',
            storeCardTotal: 'storeCardTotal'
        })
    },
    watch: {
        'storeCard': function (val, oval) {
            if (val != oval) {
                this.storeCardList = _.cloneDeep(val);
            }
        }
    },
    created() {
        // this.updateStatus(this.queryStoreCart());
    },
    methods: {
        /**
         * 立即购买
         * @param {*} data 请求所需要的数据
         * @param {*} storeCard 是否是购物车购买
         * @param {*} type  1 应用中心 2 解决方案  3 增值服务
         */
        setOrderPackage(data, type, storeCard) {
            let A = {
                combineCodeList: '',
                productList: data.productList,
                total: data.total,
                type
            };
            if (storeCard) {
                A.combineCodeList = this.createOrderByStoreCard();
            } else {
                A.combineCodeList = data.combineCodeList;
            }
            this.$storage.set(STORE_ORDER_PACKAGE, A);
            setTimeout(() => {
                this.PUSH({ name: 'store-pay-preview' });
            }, 200);
        },

        getServiceType(code) {
            switch (code) {
                case 'JMB':
                case 'MESSAGE_SERVICE':
                case 'STORE_SERVICE':
                case 'CUSTOMER_SERVICE':
                case 'CALL_SERVICE':
                    return 3;
                default:
                    return 1;
            }
        },
        createOrderByStoreCard() {
            if (!this.storeCard.length) {
                return '';
            }
            return this.storeCard.map(m => {
                return m.combineServiceCode;
            });
        },
        // 加入购物车
        addCart(infoData, dateValueChoose, dateValueIndex, payPrice) {
            let A = {
                bcsmId: infoData.bcsmId,
                combineServiceTypeName: infoData.combineServiceTypeName,
                combineServiceTitle: infoData.combineServiceTitle,
                combineServiceName: infoData.combineServiceName,
                combineServiceCode: infoData.combineServiceCode,
                showPrice: infoData.showPrice,
                discount: dateValueChoose.discount,
                dateValue: dateValueChoose.dateValue,
                dateIndex: dateValueIndex,
                payPrice: payPrice,
                infoData: infoData
            };
            let B = [];
            let count = 0;
            B = this.storeCard.map(m => {
                if (m.bcsmId == A.bcsmId) {
                    count++;
                    return A;
                }
                ;
                return m;
            });
            if (!count) {
                B.push(A);
            }
            this.$Notice.success({
                title: '成功添加购物车'
            });
            // this.updateStatus(B);
            this.setStoreCart(B);
        },
        updateStatus(data = []) {
            console.log('updateStatus', data);
            this.storeCard = data;
            this.storeCardLen = data.length;
            this.storeCardTotal = data.length > 0 ? data.map(m => m.payPrice).reduce((prev, next) => prev + next) : 0;
        },
        // 增删改查 服务市场 购物车 本地存储
        setStoreCart(data = []) {
            this.$store.commit('store/setStoreCart', data);
            // this.$storage.set(STORE_CART, data);
            // },
            // queryStoreCart() {
            //     this.$store.actions.queryStoreCart();
            // },
            // clearStoreCart() {
            //     this.setStoreCart([]);
            //     this.$storage.remove(STORE_CART);
        },
        ...mapActions({// 将 `this.clearStoreCart()` 映射为 `this.$store.dispatch('clearStoreCart')`
            clearStoreCart: 'store/clearStoreCart',
            queryStoreCart: 'store/queryStoreCart'
        })
    }
};

export default Mixins;
